<template>
	<div>
		<header-partial></header-partial>
		<div class="container text-center">
			<h1>Thank You</h1>

			<p>Your response has been received.</p>
		</div>
	</div>
</template>

<script>
import HeaderPartial from "@/layout_fragments/public/HeaderPartial"

export default {

	name: 'ThankYouPage',
	components: {
		HeaderPartial
	},
	created() {
		this.spinner(false)
	}
}
</script>
